import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUsers } from '@debbie/cortex/dist/users/index.js';
import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Errors from '../Errors.js';
import { UserPlus } from '../Icons/index.js';
import Loading from '../Loading.js';
import Modal from '../Modal.js';
import User from './User.js';
const UserSelectModal = (props) => {
    const selectMutation = useMutation((user) => Promise.resolve(props.onSelect(user)));
    const usersLoadable = useUsers();
    const allUsers = h.hasData(usersLoadable) ? usersLoadable.data : null;
    const users = (() => {
        if (!allUsers) {
            return [];
        }
        if (!props.filter) {
            return allUsers;
        }
        return allUsers.filter(props.filter);
    })();
    return (React.createElement(Modal, { header: props.header, onToggle: props.onClose, maxWidth: "670px" },
        selectMutation.isError ? (React.createElement(Errors, { errors: [
                selectMutation.error instanceof Error
                    ? selectMutation.error.message
                    : String(selectMutation.error),
            ] })) : null,
        !selectMutation.isLoading ? (React.createElement(React.Fragment, null,
            users.map((user) => (React.createElement(UserWrapper, { key: user.id },
                React.createElement(User, { user: user, onClick: (user) => selectMutation.mutate(user) })))),
            users.length === 0 && props.emptyText !== undefined && (React.createElement(EmptyText, null, props.emptyText)),
            props.invite && (React.createElement(InviteButton, { type: "button", onClick: props.invite.onInvite },
                React.createElement(UserPlus, { size: "14" }),
                React.createElement("span", null, props.invite.label))))) : (React.createElement(Center, null,
            React.createElement(Loading, { width: "40px" })))));
};
const UserWrapper = styled.div `
  cursor: pointer;
`;
const EmptyText = styled.p `
  margin: 0 0 10px;
  font-size: 12px;
  color: ${THEME.DARK_COLOR_SECONDARY};
`;
const InviteButton = styled.button `
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${THEME.COLOR_ACCENT};
  cursor: pointer;
  transition: background 0.15s ease;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    background: rgba(117, 104, 246, 0.08);
  }

  &:focus-visible {
    outline: 2px solid ${THEME.COLOR_ACCENT};
    outline-offset: 1px;
  }
`;
const Center = styled.div `
  margin: 50px auto 30px;
  text-align: center;
`;
export default UserSelectModal;
//# sourceMappingURL=UserSelectModal.js.map